import React from 'react';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { ChoiceField } from '@ns/plugin-picker-shared';

import {
  TESSA_USER_LICENSES_EMPTY_MESSAGE,
  type TessaUserLicense,
  useUserLicenses,
} from './tessa-user-licenses-query';
import { userLicensesQueryState } from './tessa-user-licenses-query-state';

/** Renders the signed-in user's active Tessa licenses on the shared choice field. */
export function TessaUserLicensePickerComponent(
  props: FieldExtensionComponentProps<TessaUserLicense>,
): React.ReactElement {
  const lookup = useUserLicenses();
  const selected = props.formData;
  const required = props.required ?? false;
  return (
    <ChoiceField<TessaUserLicense>
      description={props.schema.description}
      emptyText={TESSA_USER_LICENSES_EMPTY_MESSAGE}
      getKey={item => item.id}
      getLabel={item => item.name}
      items={lookup.data}
      label={props.schema.title ?? props.name}
      onSelect={item => props.onChange(item)}
      required={required}
      selectedKey={typeof selected?.id === 'string' ? selected.id : null}
      selectedLabel={typeof selected?.name === 'string' ? selected.name : null}
      sourceKey={lookup.sourceKey}
      state={userLicensesQueryState({
        ...lookup,
        hasItems: (lookup.data?.length ?? 0) > 0,
        required,
      })}
    />
  );
}
